import { Moment } from 'moment';

export class Project {
  constructor(private readonly id: number, private readonly uuid: string, private readonly name: string, private readonly lastAnalysis: Moment | null) {}

  getId() {
    return this.id;
  }

  getUuid() {
    return this.uuid;
  }

  getName() {
    return this.name;
  }

  getLastAnalysis() {
    return this.lastAnalysis;
  }
}
